import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01bc0953"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "notification-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SavingNotification = _resolveComponent("SavingNotification")!
  const _component_InitialNetworkError = _resolveComponent("InitialNetworkError")!
  const _component_UnrecoverableError = _resolveComponent("UnrecoverableError")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.status === _ctx.savingNotification)
        ? (_openBlock(), _createBlock(_component_SavingNotification, { key: 0 }))
        : (_ctx.status === _ctx.initialNetorkError)
          ? (_openBlock(), _createBlock(_component_InitialNetworkError, { key: 1 }))
          : (_ctx.status === _ctx.unrecoverableError || _ctx.status === _ctx.unrecoverableNetworkError)
            ? (_openBlock(), _createBlock(_component_UnrecoverableError, {
                key: 2,
                "message-detail": _ctx.getUnrecoverableErrorMessageDetail(),
                onExitTestClicked: _ctx.handleExitTest
              }, null, 8, ["message-detail", "onExitTestClicked"]))
            : _createCommentVNode("", true)
    ])
  ]))
}